import React, {useState} from 'react'
import { Box, Button, CircularProgress, Dialog, IconButton, Typography } from '@mui/material';
import { button_bg_color_for_New_Project_dm } from '../../../../../constants/colors';
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const BulkCallConformationModal = ({showModal,handleCloseModal,callCount, triggerCall, loading}) => {
    const theme = localStorage.getItem("theme");
  return (
    <div>
         <Dialog
                    open={showModal}
                    onClose={handleCloseModal}
                    maxWidth="sm"
                    PaperProps={{
                      sx: {
                        maxWidth: "480px", // Ensures modal width is capped at 480px
                        width: "100%", // Makes it responsive for smaller screens
                        borderRadius: "16px",
                        bgcolor: "#1F233E",
                        margin: "auto", // Centers the modal vertically
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    <IconButton
                      onClick={handleCloseModal}
                      sx={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        color: "white",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div
                      style={{
                        backgroundColor: theme === "dark" ? "#1F233E" : "",
                        color: theme === "dark" ? "white" : "",
                        width: "100%",
                        padding: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "60px",
                          height: "60px",
                          bgcolor: "#282D51",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        <InfoOutlinedIcon style={{ width: "36px", height: "36px" }} />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: "Inter",
                          margin: "20px 0",
                          textAlign: "center",
                        }}
                      >
                       { `Trigger calls to ${callCount} contacts?`}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0 10%",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                      {`Calls will be made to all of your ${callCount} selected contacts.`}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0 10%",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                        Do you want to proceed?
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        <Button  disabled={callCount==0}
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            bgcolor: button_bg_color_for_New_Project_dm,
                            "&:hover": {
                              bgcolor: "#ffd9aa",
                              border: "none",
                            },
                            color: "#17182C",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={triggerCall}
                        >
                        {
                            loading ?  <CircularProgress sx={{width:"12px", height:"12px", color:"#17182C"}}/> : `Yes, call ${callCount} contacts`
                        }  
                        </Button>
                        <Button
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={handleCloseModal}
                        >
                          No, cancel
                        </Button>
                      </Box>
                    </div>
                  </Dialog>
    </div>
  )
}

const  PreviousCallContactModal = ({showModal,handleCloseModal, triggerCall, loading, DeselectCallTriggeredContacts, setAllowRecalling }) => {
  const theme = localStorage.getItem("theme");
  const [window, setWindow] = useState(1)
  const handleUnselectPreviouslyCalledContactButtonClick = () => {
    //write a logic to unselect previously call users
    DeselectCallTriggeredContacts()
  }
  
    const handleCancelButtonClick = () => {
      setWindow(1);
      handleCloseModal()
    }

    const handleRecallButtonClick = () => {
      triggerCall()
    }

  return (
    <div>
         <Dialog
                    open={showModal}
                    onClose={handleCloseModal}
                    maxWidth="sm"
                    PaperProps={{
                      sx: {
                        maxWidth: "480px", 
                        width: "480px", 
                        borderRadius: "16px",
                        bgcolor: "#1F233E",
                        margin: "auto", 
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}>
                    <IconButton
                      onClick={handleCancelButtonClick}
                      sx={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        color: "white",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                    {
                      window == 1 ?
                    <div
                      style={{
                        backgroundColor: theme === "dark" ? "#1F233E" : "",
                        color: theme === "dark" ? "white" : "",
                        width: "100%",
                        padding: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "60px",
                          height: "60px",
                          bgcolor: "#282D51",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        <InfoOutlinedIcon style={{ width: "36px", height: "36px" }} />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: "Inter",
                          margin: "20px 0",
                          textAlign: "center",
                        }}
                      >
                       { `You have selected previously called contacts`}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0px 20px",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                      {`One or more contacts you have selected have already been called today. Please wait for a day to call again to avoid getting your number marked as spam.`}
                      </Typography>
                      {/* <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0 10%",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                        Do you want to proceed?
                      </Typography> */}
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            bgcolor: button_bg_color_for_New_Project_dm,
                            "&:hover": {
                              bgcolor: "#ffd9aa",
                              border: "none",
                            },
                            color: "#17182C",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={()=>{handleUnselectPreviouslyCalledContactButtonClick()}}
                        >
                        {`Unselect previously called contacts`}
                        </Button>
                        <Button
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={()=>{setAllowRecalling(true); setWindow(2)}}
                        >
                          Trigger calls anyway
                        </Button>
                      </Box>
                    </div>
                      :
                    <div
                      style={{
                        backgroundColor: theme === "dark" ? "#1F233E" : "",
                        color: theme === "dark" ? "white" : "",
                        width: "100%",
                        padding: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "60px",
                          height: "60px",
                          bgcolor: "#282D51",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        <InfoOutlinedIcon style={{ width: "36px", height: "36px" }} />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: "Inter",
                          margin: "20px 0",
                          textAlign: "center",
                        }}
                      >
                       { `Call previously called contacts?`}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0 10%",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                      {`Are you sure you want to trigger calls to contacts you have already called today? This action might get your phone number marked as spam`}
                      </Typography>
                      {/* <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Inter",
                          padding: "0 10%",
                          textAlign: "center",
                          marginBottom: "20px",
                          color: "rgba(255, 255, 255, 0.80)",
                        }}
                      >
                        Do you want to proceed?
                      </Typography> */}
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            bgcolor: button_bg_color_for_New_Project_dm,
                            "&:hover": {
                              bgcolor: "#ffd9aa",
                              border: "none",
                            },
                            color: "#17182C",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={handleRecallButtonClick}
                        >
                        {/* {`Yes, trigger calls`} */}
                        { loading ?  <CircularProgress sx={{width:"12px", height:"12px", color:"#17182C"}}/> : `Yes, trigger calls` } 
                        </Button>
                        <Button
                          sx={{
                            width: "90%",
                            maxWidth: "400px",
                            textTransform: "none",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Inter",
                          }}
                          onClick={handleCancelButtonClick}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </div>
                    }
                  
          </Dialog>
    </div>
  )
}

export default BulkCallConformationModal
export { PreviousCallContactModal }